var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"decorativeCom"},[_c('div',{style:({
        'background': ("url('" + (_vm.configImgUrl()) + (_vm.config.borImg) + "')"),
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }